import { useEffect, useState } from 'react';
import { useColorMode } from '@chakra-ui/react';

type SpeechBalloonProps = {
  text: string;
  className?: string;
  onTypingComplete?: () => void;
  description?: string;
  containerClassName?: string;
};

const SpeechBalloon = ({
  text,
  className = '',
  onTypingComplete,
  description,
  containerClassName = ''
}: SpeechBalloonProps) => {
  const SPEED = 100;
  const [displayText, setDisplayText] = useState('');
  const { colorMode } = useColorMode();

  useEffect(() => {
    let i = 0;
    setDisplayText('');
    const textArray = Array.from(text);
    const timer = setInterval(() => {
      setDisplayText(textArray.slice(0, i + 1).join(''));
      i++;
      if (i >= textArray.length) {
        clearInterval(timer);
        onTypingComplete?.();
      }
    }, SPEED);

    return () => clearInterval(timer);
  }, [text, onTypingComplete]);

  return (
    // shadow는 래퍼에만: 본체+꼬리를 한 덩어리로 그림자 계산
    <div
      className={`relative inline-block align-top ${className}`}
      style={{
        maxWidth: 296,
        filter: 'drop-shadow(0 0 8px rgba(0,0,0,0.04)) drop-shadow(0 0 3px rgba(0,0,0,0.07))',
        isolation: 'isolate',
        transform: 'translateZ(0)',
        WebkitTransform: 'translateZ(0)',
        willChange: 'filter, transform',
        backfaceVisibility: 'hidden',
        WebkitBackfaceVisibility: 'hidden'
      }}
    >
      {/* 본체 */}
      <div
        className={`relative bg-pure-white dark:bg-pure-black rounded-[20px] ${containerClassName}`}
        style={{ padding: '20px 24px' }}
      >
        <p className="text-[17px] font-semibold leading-[20px] text-text-main-lv2 text-center whitespace-pre-wrap break-words">
          {displayText}
          {displayText.length < text.length - 1 && <span className="animate-pulse">|</span>}
        </p>
        {description && displayText.length === text.length && (
          <p className="text-[11px] font-semibold leading-[13px] text-text-main-lv4 text-center whitespace-pre-wrap break-words mt-[8px]">
            {description}
          </p>
        )}
      </div>

      {/* 꼬리 */}
      <svg
        width={26}
        height={27}
        viewBox="0 0 26 27"
        className="absolute left-1/2 pointer-events-none"
        style={{
          bottom: -12,
          transform: 'translateX(-48%)',
          transformOrigin: '50% 0%'
        }}
        aria-label="Chat Bubble Tail"
        role="img"
      >
        <path
          d="M17.2619 24.0135C15.4864 27.9243 9.93178 27.9243 8.15631 24.0135L0.5809 7.32741C-0.921955 4.01713 1.49822 0.260468 5.13367 0.260469L20.2845 0.26047C23.92 0.260471 26.3401 4.01713 24.8373 7.32741L17.2619 24.0135Z"
          fill={colorMode === 'light' ? '#FFFFFF' : '#222222'}
        />
      </svg>
    </div>
  );
};

export default SpeechBalloon;
